const environments = {
  development: {
    NAME: 'development',
    HOST: 'http://localhost:5001',
  },
  staging: {
    NAME: 'staging',
    HOST: 'http://192.168.87.101:5001',
  },
  production: {
    NAME: 'production',
    HOST: `/proxy`,
  },
};

const environment = process.env.NODE_ENV || 'development';

// // disabling reacts yellow boxes
// if (environment === 'development') {
//   console.disableYellowBox = true;
// }

export default environments[environment];



// WEBPACK FOOTER //
// ./src/environment.js